import {ModuleWithProviders, NgModule} from '@angular/core';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {SUPPORTED_LANGS} from './lang.tokens';
import {fileLoaderFactory} from './file-loader-factory';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: fileLoaderFactory,
        deps: [SUPPORTED_LANGS]
      },
      isolate: true
    })
  ],
  exports: [
    TranslateModule
  ]
})
export class TranslationModule {

  constructor(private readonly translateService: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translateService.setDefaultLang('de');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translateService.use('de');
  }

  static forChild({deLang}): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: [
        {
          provide: SUPPORTED_LANGS,
          useValue: {
            de: deLang
          },
          multi: true
        }
      ]
    };
  }
}
